import {gql} from '@apollo/client';
import {COMPETITOR_FRAGMENT} from '../../fragments';

export const GET_GROUPS = gql`
  query getGroups($tournamentId: ID!) {
    getGroups(tournamentId: $tournamentId) {
      groupNumber
      members {
        clubName
        fullName
        phoneNumber
      }
    }
  }
`;

export const GET_STANDING = gql`
  ${COMPETITOR_FRAGMENT}
  query getStanding($tournamentId: ID!) {
    getStanding(tournamentId: $tournamentId) {
      table {
        ...CompetitorParts
      }
      tournamentId
    }
  }
`;

export const GET_NUMBER_OF_ROUNDS = gql`
  query getNumberOfRounds($tournamentId: ID!) {
    getNumberOfRounds(tournamentId: $tournamentId)
  }
`;

export const GET_ROUND = gql`
  query getRound($tournamentId: ID!, $roundNumber: Int!) {
    getRound(tournamentId: $tournamentId, roundNumber: $roundNumber) {
      tableNumber
      competitorOne {
        name
        result
      }
      competitorTwo {
        name
        result
      }
    }
  }
`;

export const NOTIFY_PARTICIPANTS = gql`
  query notifyParticipants($tournamentId: ID!, $round: NotifyRoundInput!) {
    notifyParticipants(tournamentId: $tournamentId, round: $round)
  }
`;
